import App from "./app";
import ServiceM8Callback from "./servicem8";

const routes = [
  {
    type: "collapse",
    key: "app",
    route: "/app/:appId",
    component: <App />,
  },
  {
    type: "collapse",
    key: "servicem8",
    route: "/servicem8",
    component: <ServiceM8Callback />,
  },
];

export default routes;
